import { useDepositoContext } from "@/features/inventario/deposito-actual/contexts/deposito-context";
import { Alert, Stack, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import { teal } from "@mui/material/colors";
import WarehouseIcon from "@mui/icons-material/Warehouse";

const StyledAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: teal[700],
    color: theme.palette.success.contrastText,
    paddingTop: 0,
    paddingBottom: 0
}))

export default function DepositoLabel() {

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const { depositoData } = useDepositoContext();
    if (!depositoData) return <></>

    return <StyledAlert icon={false}>
        <Stack direction="row" alignItems="center" gap={0.5}>
            <WarehouseIcon sx={{ fontSize: { xs: 12, sm: 14 }, color: "inherit", opacity: 0.85 }} />
            <Typography variant="subtitle2" fontSize={{ xs: "0.6rem", sm: "0.8rem" }}>
                {`${depositoData.nombre}${depositoData.principal && !smallScreen ? " - Principal" : ""}`}
            </Typography>
        </Stack>
    </StyledAlert>
}
